import { render, staticRenderFns } from "./ListFondosCard.vue?vue&type=template&id=71fd43a4"
import script from "./ListFondosCard.vue?vue&type=script&lang=js"
export * from "./ListFondosCard.vue?vue&type=script&lang=js"
import style0 from "./ListFondosCard.vue?vue&type=style&index=0&id=71fd43a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports